import { combineReducers } from 'redux'

import siteInfo from './reducers/siteInfo'
import userInfo from './reducers/userInfo'
import siteThemeSettings from './reducers/siteThemeSettings'
import appAlerts from './reducers/appAlerts'

export default combineReducers({
  siteInfo, userInfo, siteThemeSettings, appAlerts
})